// @flow
import { FOLLOW_SELLER_SUCCESS, UNFOLLOW_SELLER_SUCCESS } from './followSeller';
import api from '../api/seller';
import cloneDeep from 'lodash/cloneDeep';
import { createSelector } from 'reselect';
import difference from 'lodash/difference';
import { getAuthToken } from './user';
import { getDeployment } from './config';
import type { GlobalState } from '../rootReducer';
import union from 'lodash/union';

/* Action Types */
export const LOAD_SELLER_FOLLOWER_COUNT_FAIL = 'la/domain/sellerFollowerCount/LOAD_FAIL';
export const LOAD_SELLER_FOLLOWER_COUNT_REQUEST = 'la/domain/sellerFollowerCount/LOAD_REQUEST';
export const LOAD_SELLER_FOLLOWER_COUNT_SUCCESS = 'la/domain/sellerFollowerCount/LOAD_SUCCESS';

/* reducer */
const DEFAULT_STATE = {
    byId: {},
    loading: [],
    loadingSellersFollowerCount: false,
};

export type State = {|
    ...typeof DEFAULT_STATE,
|};

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    let sellerIds;

    switch (action.type) {
        case LOAD_SELLER_FOLLOWER_COUNT_FAIL:
            return {
                ...state,
                loading: difference(state.loading, action.payload.sellerIds),
                loadingSellersFollowerCount: false,
            };
        case LOAD_SELLER_FOLLOWER_COUNT_REQUEST:
            return {
                ...state,
                loading: union(state.loading, action.payload),
                loadingSellersFollowerCount: true,
            };
        case LOAD_SELLER_FOLLOWER_COUNT_SUCCESS:
            let existing = cloneDeep(state.byId);
            action.payload.forEach(sellerFollowerCount => {
                existing = { ...existing, ...sellerFollowerCount };
            });
            return {
                ...state,
                byId: existing,
                loading: difference(state.loading, sellerIds),
                loadingSellersFollowerCount: false,
            };
        case FOLLOW_SELLER_SUCCESS:
            let followExisting = cloneDeep(state.byId);
            followExisting[action.payload] = followExisting[action.payload] + 1;
            return {
                ...state,
                byId: followExisting,
            };
        case UNFOLLOW_SELLER_SUCCESS:
            let unfollowExisting = cloneDeep(state.byId);
            unfollowExisting[action.payload] = unfollowExisting[action.payload] - 1;
            return {
                ...state,
                byId: unfollowExisting,
            };
        default:
            return state;
    }
}

/* SELECTORS */
const stateSelector = (state: GlobalState) => state.sellerFollowerCount;
const idSelector = (state: GlobalState, id) => id;

const byIdSelector = createSelector(stateSelector, state => state.byId);

export const getSellerFollowerCountById = createSelector([byIdSelector, idSelector], (byId, id) => byId[id] || 0);

/* ACTION CREATORS */
// all sellers

export const fetchSellerFollowerCount = (sellerIds: number[]) => {
    return async (dispatch: Function, getState: Function) => {
        try {
            const state = getState();
            const authToken = getAuthToken(state);
            const deployment = getDeployment(state);
            dispatch({
                payload: sellerIds,
                type: LOAD_SELLER_FOLLOWER_COUNT_REQUEST,
            });
            const results = await api.fetchFollowerCount({ authToken, deployment, sellerIds });
            dispatch({
                meta: { sellerIds },
                payload: results.data,
                type: LOAD_SELLER_FOLLOWER_COUNT_SUCCESS,
            });
        } catch (error) {
            dispatch({
                payload: { error, sellerIds },
                type: LOAD_SELLER_FOLLOWER_COUNT_FAIL,
            });
        }
    };
};
